<template>
<div class="chapter">
<div class="inner_page">
<h1 class="part" id="p01"><a id="page_7"></a>PART ONE</h1>
<h1 class="part1">Independence</h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780795344114_epub_p01_r1.vue?7422f6ff